var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background"},[_c('div',{staticClass:"mainPage"},[_c('imageEditer'),_c('bottomBar')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }